import React from "react";

const Comment = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M2 18C2 9.163 9.163 2 18 2s16 7.163 16 16-7.163 16-16 16H2l4.686-4.686A15.951 15.951 0 012 18zm7.725 12.8H18A12.8 12.8 0 105.2 18c0 3.443 1.362 6.664 3.749 9.051l2.262 2.263L9.725 30.8z"
          fill={fill}
      />
      <rect
          className="u_fill"
          x={9.111}
          y={16.222}
          width={3.556}
          height={3.556}
          rx={1.778}
          fill={fill}
      />
      <rect
          className="u_fill"
          x={16.222}
          y={16.222}
          width={3.556}
          height={3.556}
          rx={1.778}
          fill={fill}
      />
      <rect
          className="u_fill"
          x={23.333}
          y={16.222}
          width={3.556}
          height={3.556}
          rx={1.778}
          fill={fill}
      />
    </svg>
);

export default Comment;
